import { Helmet } from 'react-helmet';

import { buildContentSeoMetadata, buildContentStructuredData } from '@/utils/contentSeo.utils';
import {
  buildLocalizedAlternateUrls,
  resolveCurrentPathLocale,
  resolveLocalizedCanonicalUrl,
} from '@/utils/localePublicUrl';

export default function ContentMetaDesc({ content }) {
  const metadata = buildContentSeoMetadata(content);
  const structuredData = buildContentStructuredData(content, metadata);
  const resolvedLocale = resolveCurrentPathLocale();
  const resolvedCanonicalUrl = resolveLocalizedCanonicalUrl({ canonicalUrl: metadata.canonicalUrl, locale: resolvedLocale });
  const alternateUrls = buildLocalizedAlternateUrls({ canonicalUrl: metadata.canonicalUrl, locale: resolvedLocale });

  return (
    <Helmet>
      <html lang={resolvedLocale} />
      <title>{metadata.title}</title>
      <meta name="description" content={metadata.metaDescription} />
      <meta name="robots" content={metadata.robots} />
      <meta name="googlebot" content={metadata.robots} />
      <link rel="canonical" href={resolvedCanonicalUrl} />
      {alternateUrls.map((alternate) => (
        <link key={alternate.hrefLang} rel="alternate" hrefLang={alternate.hrefLang} href={alternate.href} />
      ))}
      <meta property="og:type" content={metadata.ogType || 'article'} />
      <meta property="og:title" content={metadata.title} />
      <meta property="og:description" content={metadata.metaDescription} />
      <meta property="og:url" content={resolvedCanonicalUrl} />
      <meta property="og:image" content={metadata.ogImage} />
      <meta property="og:site_name" content="Suarte" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metadata.title} />
      <meta name="twitter:description" content={metadata.metaDescription} />
      <meta name="twitter:image" content={metadata.ogImage} />
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}
